import React, { useCallback, useState } from "react";
import {
  Carousel,
  Container,
  ImageGalleryModal,
  Pressable,
} from "../components";
import { ImageData } from "../data";

export interface ImageGalleryProps {
  name: string;
  images: ImageData[];
  imagesModal?: ImageData[];
  featuredPromoRibbon?: React.ReactNode;
}

const height = 280;

export function ImageGalleryMobile(props: ImageGalleryProps) {
  const { name, images, featuredPromoRibbon } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const items = images.map((image) => ({
    src: image.url,
    w: image.width,
    h: image.height,
  }));

  const handleOpen = useCallback((index) => {
    setIsOpen(true);
    setIndex(index);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  if (images.length === 0) {
    return (
      <div
        style={{
          height,
          boxSizing: "border-box",
          display: "flex",
          position: "relative",
        }}
      />
    );
  }

  return (
    <div>
      <Carousel>
        {images.map((image, index) => (
          <Pressable
            style={{ width: "100%" }}
            key={image.url}
            onPress={() => handleOpen(index)}
          >
            <Container overflow="hidden">
              {featuredPromoRibbon}
              <img
                style={{
                  objectFit: "cover",
                  height,
                  width: "100%",
                }}
                src={image.url}
                alt={`${name} thumbnail`}
              />
            </Container>
          </Pressable>
        ))}
      </Carousel>
      <ImageGalleryModal
        isOpen={isOpen}
        index={index}
        items={items}
        onClose={handleClose}
      />
    </div>
  );
}
